import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface ExportIglooStaffKeyLogsRequest {
  buildingId: number | string
  endDate: string
  startDate: string
}

export const exportIglooStaffKeyLogs = async ({
  buildingId,
  endDate,
  startDate,
}: ExportIglooStaffKeyLogsRequest): Promise<Blob | null> => {
  const response = await authAPI.get<Blob>(
    `/igloowork/building/${buildingId}/staff/master-key/logs/export`,
    {
      params: { endDate, startDate },
      responseType: 'blob',
    },
  )

  return response.status === 204 ? null : response.data
}

export const useExportIglooStaffKeyLogs = () =>
  useMutation({
    mutationFn: exportIglooStaffKeyLogs,
  })
